import { useState } from 'react'
import { Link, createFileRoute } from '@tanstack/react-router'
import { api, call } from '../lib/api'
import { AuthButton, AuthInput, AuthLayout, FormError } from '../components/auth'

export const Route = createFileRoute('/forgot-password')({ component: Forgot })

function Forgot() {
  const [sent, setSent] = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: React.SubmitEvent<HTMLFormElement>) {
    e.preventDefault()
    const email = String(new FormData(e.currentTarget).get('email'))
    setBusy(true)
    setError(null)
    try {
      await call(api.auth.forgot.$post({ json: { email } }))
      setSent(email)
    } catch (err) {
      setError((err as Error).message)
    }
    setBusy(false)
  }

  return (
    <AuthLayout title="Reset password" subtitle={sent ? 'Check your inbox.' : "Enter your email and we'll send you a reset link."}>
      {sent ? (
        <div className="space-y-6">
          <p className="text-ink-2">If <b className="text-ink">{sent}</b> has a GasRail account, a link to choose a new password is on its way. It expires in an hour.</p>
          <Link to="/login" className="font-semibold text-brand hover:underline">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit}>
          <FormError error={error} />
          <AuthInput label="Email" name="email" type="email" autoComplete="email" placeholder="enter your email address" required autoFocus />
          <AuthButton busy={busy}>Send reset link</AuthButton>
          <p className="mt-6 text-center text-sm"><Link to="/login" className="font-semibold text-brand hover:underline">Back to sign in</Link></p>
        </form>
      )}
    </AuthLayout>
  )
}
